import {EventEmitter, Injectable} from '@angular/core';
import 'rxjs/Rx';
import {ErrorCode} from './util.service';
import {LoggerService} from './logger.service';
import {ModalService} from './modal.service';
import {SweetAlertOptions} from 'sweetalert2';

// alert box types
export type AlertType = 'error' | 'message' | 'pollChanged' | '';

export class AlertMessage {
    msg: string;
    code: number;
    type: AlertType;
    html: string;
    confirmButtom: string;

    constructor(data: string | ErrorCode, type: AlertType, html?: string, confirmButtom?: any) {
        console.log('typeof data=', typeof data);

        this.type = type;
        this.html = html;
        this.confirmButtom = confirmButtom;

        if (typeof data === 'object') {
            this.msg = data.msg;
            this.code = data.code;
        } else {
            this.msg = data;
        }
    }

}

@Injectable()
export class AlertService {

    alertEvent: EventEmitter<AlertMessage> = new EventEmitter<AlertMessage>(true);
    private useAlertEvent: boolean = false;

    constructor(private modalService: ModalService,
                private logger: LoggerService) {
    }

    public setUseAlertEvent(useAlertEvent: boolean) {
        this.useAlertEvent = useAlertEvent;
    }

    emit(alert: AlertMessage) {
        this.logger.log('AlertService: emit', alert);

        if (this.useAlertEvent) {
            this.alertEvent.emit(alert);
            return null;
        }

        if (alert && alert.msg) {
            let type = '';
            let title = alert.msg;
            let html = alert.html || '';

            switch (alert.type) {
                case 'error':
                    type = 'error';
                    break;

                case 'message':
                    type = 'info';
                    break;

                case 'pollChanged':
                    type = 'warning';
                    break;

                default:
                    break;
            }

            let params = {
                title: title,
                html: html,
                type: type,
                confirmButtonColor: '#3085d6'
            } as SweetAlertOptions;

            if (alert.confirmButtom) {
                params.confirmButtonText = alert.confirmButtom;
                params.showCancelButton = true;
            }

            return this.modalService.showAlert(params);
        }
    }

    subscribe(callback: any) {
        // this.logger.log('AlertService: subscribe', callback);
        return this.alertEvent.subscribe((alert: any) => callback(alert));
    }
}
